<template>
  <v-sheet v-if="item">
    <v-list class="pb-0">
      <v-list-item class="py-3">
        <v-list-item-avatar size="40">
          <ProxyImage :src="item.primary_picture" alt="Item"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle>
            <div class="blue-grey--text font-weight-bold">
              {{ item.monthly_amount | currency }} for {{ item.no_of_months }} month(s)
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn @click="$emit('close')" color="red" icon outlined>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="px-6 py-10">
        <div class="fill-width d-flex justify-space-between align-center">
          <p class="text-title grey--text">Edit quantity</p>
          <div>
            <v-text-field :value="item.unit" dense outlined readonly style="width: 150px">
              <v-icon @click="$store.commit('cart/decreaseQuantity', item.id)" color="red" slot="prepend">
                mdi-minus
              </v-icon>
              <v-icon @click="$store.commit('cart/increaseQuantity', item.id)" color="green" slot="append-outer">
                mdi-plus
              </v-icon>
            </v-text-field>
          </div>
        </div>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-card-actions class="px-6">
      <v-btn @click="remove(item)" text>
        Remove item from cart
      </v-btn>
    </v-card-actions>
  </v-sheet>
</template>
<script>
import ProxyImage from "../ProxyImage";

export default {
  name: 'CartListItemContent',
  components: { ProxyImage },
  props: {
    item: {
      required: true
    },
  },
  methods: {
    remove(item) {
      this.$store.commit('cart/removeItem', item.id);
      this.$emit('close');
    }
  }
}
</script>
